import type { ReactNode } from 'react';

import { Stack } from '../Stack';

const MOBILE_DIRECTION = 'column';

type Props = {
  direction?: 'row' | 'column';
  children: ReactNode;
};

export function FormStack(props: Props) {
  const { direction = MOBILE_DIRECTION } = props;

  return (
    <Stack direction={{ xs: MOBILE_DIRECTION, sm: direction }} spacing={1}>
      {props.children}
    </Stack>
  );
}

export type { Props as FormStackProps };
